module.exports = __webpack_public_path__ + "static/media/group-management.c5cfc810.svg";